import { render } from "./examinaDetails.vue?vue&type=template&id=a5a65cda&scoped=true"
import script from "./examinaDetails.vue?vue&type=script&lang=js"
export * from "./examinaDetails.vue?vue&type=script&lang=js"

import "./examinaDetails.vue?vue&type=style&index=0&id=a5a65cda&lang=scss&scoped=true"

import exportComponent from "E:\\wwwroot\\qifu-web-v1.0.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5a65cda"]])

export default __exports__